import {
  OPEN_MERGE_COMMAND_DRAWER,
  CLOSE_MERGE_COMMAND_DRAWER,
  GET_COMMANDS_FOR_MERGE_SUCCESS,
  MERGE_COMMANDS_SUCCESS
} from './mergeCommandsActions';

const initialState = {
  openDrawer: false,
  commandsForMerge: [],
  mergeCommandWatch: false
};

const mergeCommansReducer = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_MERGE_COMMAND_DRAWER:
      return {
        ...state,
        openDrawer: true
      };
    case CLOSE_MERGE_COMMAND_DRAWER:
      return {
        ...state,
        openDrawer: false
      };
    case GET_COMMANDS_FOR_MERGE_SUCCESS:
      return {
        ...state,
        commandsForMerge: action.payload
      };
    case MERGE_COMMANDS_SUCCESS:
      return {
        ...state,
        mergeCommandWatch: !state.mergeCommandWatch,
        openDrawer: false
      };
    default:
      return state;
  }
};

export default mergeCommansReducer;
